import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import { DiMaDetailsHeaderProps } from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { DetailsHeaderTabLayout } from "../../../components/Helpers"
import { UserContext } from "../../../context/UserContext"
import { FileGet } from "../../../models/File"
import { useHashTab } from "../../../../hooks/useHashTab"
import { FileDetails } from "./details_tab/FileDetails"
import { FileSharing } from "./sharing_tab/FileSharing"
import { FileVersions } from "./versions_tab/FileVersions"

const returnURL = "/files"

export function FileContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { fileId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [file, setFile] = useState<FileGet>()

  useEffect(() => {
    if (fileId) {
      digitalManagerApi
        .get<FileGet>(`/files/${fileId}`)
        .then((res) => {
          setFile(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [fileId, navigate])

  if (!fileId) {
    return <Navigate to={returnURL} />
  }

  if (!file || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: `${file.name}.${file.extension}`,
    label: "ID",
    subtitle: file.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTabLayout
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "versions", label: "Versions" },
          { id: "sharing", label: "Sharing" },
        ]}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && (
        <FileDetails file={file} user={user} setFile={setFile} />
      )}

      {activeTab === "versions" && <FileVersions />}

      {activeTab === "sharing" && <FileSharing />}
    </div>
  )
}
